function* createAuthors<T, U>(
  authors: T[],
  AuthorComponent: (props: T & U) => JSX.Element,
  rest: U
) {
  let i = 0;

  while (i < authors.length) {
    const author = authors[i];

    if (authors.length > 1 && i === authors.length - 1) {
      yield " and ";
    }

    if (author) {
      yield (<AuthorComponent {...author} {...rest} key={`author-${i}`} />);
    }

    if (authors.length > 2 && i !== authors.length - 1) {
      yield ", ";
    }

    i += 1;
  }
}

const Authors = <T, U>({
  component,
  authors,
  ...props
}: {
  authors: T[];
  component: (props: T & U) => JSX.Element;
} & U) => {
  return (
    <>
      {Array.from(createAuthors(authors, component, (props as unknown) as U))}
    </>
  );
};

export default Authors;
